import React from 'react';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: string;
  className?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, icon, className = "" }) => {
  const isCashback = title.includes('Cash Back');
  return (
    <div className={`${isCashback ? 'p-8' : 'p-6'} rounded-lg shadow-md hover:shadow-lg transition-shadow ${className || 'bg-white'}`}>
      <div className={`${isCashback ? 'text-6xl' : 'text-4xl'} mb-4`}>{icon}</div>
      <h3 className={`${isCashback ? 'text-3xl font-black text-blue-900' : 'text-xl font-semibold text-gray-900'} mb-2`}>{title}</h3>
      <p className={isCashback ? 'text-blue-800 font-bold text-lg' : 'text-gray-600'}>{description}</p>
    </div>
  );
};

export default FeatureCard;
